import React, { useState } from 'react';
import { Box, Button, Input, Table, Thead, Tbody, Tr, Th, Td, Flex, Heading, Text, IconButton, useColorModeValue } from '@chakra-ui/react';
import { FaTrash, FaSyncAlt, FaPlus } from 'react-icons/fa';

const initialData = [
  { name: 'QA Test Automation Company', sector: 'Other', empPrefix: 'N/A', country: 'Kenya', currency: 'KES' },
  { name: 'QA Automation Company 2', sector: 'Other', empPrefix: 'N/A', country: 'Kenya', currency: 'KES' },
  { name: 'Kamaus Inc', sector: 'Other', empPrefix: 'N/A', country: 'Kenya', currency: 'KES' },
];

export default function SettingsOrganisationTab() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState('');

  // Chakra color mode values
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const tableHeaderBg = useColorModeValue('green.50', 'gray.700');
  const tableHeaderColor = useColorModeValue('green.700', 'green.200');
  const tableRowBgEven = useColorModeValue('white', 'gray.800');
  const tableRowBgOdd = useColorModeValue('gray.50', 'gray.700');
  const inputBg = useColorModeValue('gray.50', 'gray.700');
  const inputBorder = useColorModeValue('gray.200', 'gray.600');


  const filtered = data.filter(row =>
    row.name.toLowerCase().includes(search.toLowerCase()) ||
    row.sector.toLowerCase().includes(search.toLowerCase()) ||
    row.country.toLowerCase().includes(search.toLowerCase()) ||
    row.currency.toLowerCase().includes(search.toLowerCase())
  );

  const handleRefresh = () => {
    // Implementation of handleRefresh
    console.log('Refresh Organisations'); // Placeholder
  };

  const handleNewCompany = () => {
    // Implementation of handleNewCompany
     console.log('New Company'); // Placeholder
  };

  const handleDelete = (name) => {
    // Implementation of handleDelete
    console.log('Delete Organisation:', name); // Placeholder
    setData(data.filter(org => org.name !== name)); // Simple state update for demo
  };

  return (
    <Box>
      <Heading as="h3" size="md" mb={2} color={textColor}>Organisations</Heading>
      <Text fontSize="sm" color="gray.500" mb={6}>Manage your organisations and company branches.</Text>
      <Flex align="center" mb={6} justify="space-between" flexWrap="wrap" gap={4}>
        <Flex gap={2}>
          <Button leftIcon={<FaSyncAlt />} colorScheme="green" onClick={handleRefresh} size="sm" borderRadius="lg">Refresh</Button>
          <Button leftIcon={<FaPlus />} colorScheme="green" onClick={handleNewCompany} size="sm" borderRadius="lg">New Company</Button>
        </Flex>
        <Input
          placeholder="Search"
          value={search}
          onChange={e => setSearch(e.target.value)}
          size="sm"
          borderRadius="full"
          maxW="220px"
          minW="120px"
          bg={inputBg}
          borderColor={inputBorder}
        />
      </Flex>
      
      {/* Removed error and loading placeholders as no such logic is currently in the file */}

      <Box overflowX="auto" borderRadius="lg" boxShadow="md" borderWidth={1} borderColor={borderColor} bg={cardBg}>
        <Table variant="simple" size="sm">
          <Thead bg={tableHeaderBg}>
            <Tr>
              <Th color={tableHeaderColor} py={3}>Name</Th>
              <Th color={tableHeaderColor} py={3}>Sector</Th>
              <Th color={tableHeaderColor} py={3}>Emp. prefix</Th>
              <Th color={tableHeaderColor} py={3}>Country</Th>
              <Th color={tableHeaderColor} py={3}>Currency</Th>
              <Th textAlign="right" py={3}></Th>
            </Tr>
          </Thead>
          <Tbody>
            {filtered.length === 0 ? (
              <Tr>
                <Td colSpan={6} textAlign="center" py={8} color="gray.500">No organisations found.</Td>
              </Tr>
            ) : (
              filtered.map((row, i) => (
                <Tr key={row.name} bg={i % 2 === 0 ? tableRowBgEven : tableRowBgOdd}>
                  <Td color={textColor}>{row.name}</Td>
                  <Td color={textColor}>{row.sector}</Td>
                  <Td color={textColor}>{row.empPrefix}</Td>
                  <Td color={textColor}>{row.country}</Td>
                  <Td color={textColor}>{row.currency}</Td>
                  <Td textAlign="right">
                     <IconButton
                      aria-label="Delete organisation"
                      icon={<FaTrash />}
                      size="sm"
                      variant="ghost"
                      colorScheme="red"
                      onClick={() => handleDelete(row.name)}
                    />
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
} 